export * from './sapi-locale.adapter';
